import { ApplicationTypes, KickPlate, Model } from 'metalworks-domain'

import { configuratorInterface } from '../configurator-interface'

/*
 * Kickplate can have 0-1 features. When a feature is added, it should not be possible to deselect it.
 */
export const ignoreKickPlateFeatureDetectionTransformer = configuratorInterface.transformerBuilder.when
  .entity(Model.Feature.types)
  .deselected()
  .then.applySideEffect(ctx => {
    const navigationState = ctx.getNewNavigationState()

    if (navigationState !== ApplicationTypes.NavigationState.Features) {
      return []
    }

    const plate = ctx.getNew$Root()
    if (!KickPlate.is(plate)) {
      return []
    }

    const firstHole = plate.$holes[0]
    if (!firstHole) {
      return []
    }

    return [ctx.domainContext.navigationSystem.getSelectUpdate(firstHole.id)]
  })
  .build('Re-select first kick plate hole when feature is deselected')
